module.exports = __webpack_public_path__ + "img/product1.44b7dfb9.png";